import { render, staticRenderFns } from "./shifts-list.vue?vue&type=template&id=acb6d62c&scoped=true&"
import script from "./shifts-list.js?vue&type=script&lang=js&"
export * from "./shifts-list.js?vue&type=script&lang=js&"
import style0 from "./shifts-list.scss?vue&type=style&index=0&id=acb6d62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb6d62c",
  null
  
)

export default component.exports